import React, {FC} from 'react';
import {CFormLabel} from "@coreui/react";
import Select from "react-select";

import {IState} from "./EsFeed";
import {IRegionResponse} from "../../../interfaces/IRegions";

interface IFilterBlock {
  regions: IRegionResponse[]
  districts: any[]
  onSelect: (e: any, name: string) => void
  state: IState
  t: (value: string) => string
  classname?: string
}

interface ISelectOptions {
  label: string,
  value: string
}

const FilterBlock: FC<IFilterBlock> = ({regions, districts, onSelect, state, t, classname}) => {

  let regionsOptions: ISelectOptions[] = [], districtsOptions: ISelectOptions[] = [];

  if (regions?.length) {
    regionsOptions = regions.map(el => {
      return {label: el.name, value: String(el.id)}
    })
  }

  if (districts?.length && state.region) {
    districtsOptions = districts.filter(el => String(el.region) === state.region).map(el => {
      return {label: el.name, value: String(el.id)}
    })
  }

  const reportTypeOptions: ISelectOptions[] = [
    {label: t('emergency.incident'), value: 'incident'},
    {label: t('emergency.emergency'), value: 'emergency'},
    {label: t('emergency.other'), value: 'other'}
  ];

  const statusOptions: ISelectOptions[] = [
    {label: t('esFeed.inProcess'), value: 'in processing'},
    {label: t('esFeed.completed'), value: 'completed'}
  ];

  const reportStatusOptions: ISelectOptions[] = [
    {label: t('esFeed.informationWithDelay'), value: 'true'},
    {label: t('esFeed.informationWithoutDelay'), value: 'false'}
  ];

  const reactSelectControlStyles = (baseStyles: any, state: any): any => {
    return {
      ...baseStyles,
      '&:hover': {
        borderColor: state.isFocused ? '#998fed' : '#d8dbe0'
      },
      borderRadius: '6px',
      borderColor: state.isFocused ? '#998fed' : '#d8dbe0',
      boxShadow: state.isFocused ? '0 0 0 0.25rem rgba(50, 31, 219, 0.25)' : 'unset',
      marginBottom: '5px'
    }
  };

  return (
      <div className={`filter-block-wrapper desktop-only ${classname}`}>
          <div style={{width: '25%'}}>
          <CFormLabel>{t("settings.regions.region")}</CFormLabel>
              <Select options={regionsOptions}
                      value={regionsOptions?.find(el => el.value === state.region)}
                      styles={{control: (baseStyles, state) => (reactSelectControlStyles(baseStyles, state))}}
                      placeholder={t('All')}
                      onChange={e => onSelect(e, 'region')}
                      isClearable
              />
          </div>
          <div style={{width: '25%'}}>
              <CFormLabel>{t("settings.regions.district")}</CFormLabel>
              <Select
                  options={districtsOptions}
                  value={districtsOptions?.find(el => el.value === state.district) || ''}
                  styles={{control: (baseStyles, state) => (reactSelectControlStyles(baseStyles, state))}}
                  placeholder={t('All')}
                  onChange={e => onSelect(e, 'district')}
                  isClearable
                  isDisabled={!state?.region}
              />
          </div>
          <div style={{width: '25%'}}>
              <CFormLabel>{t("emergency.typeOfReport")}</CFormLabel>
              <Select options={reportTypeOptions}
                      value={reportTypeOptions?.find(el => el.value === state.reportType)}
                      styles={{control: (baseStyles, state) => (reactSelectControlStyles(baseStyles, state))}}
                      placeholder={t('All')}
                      onChange={e => onSelect(e, 'reportType')}
                      isClearable
              />
          </div>
          <div style={{width: '25%'}}>
              <CFormLabel>{t("emergency.status")}</CFormLabel>
              <Select options={statusOptions}
                      value={statusOptions?.find(el => el.value === state.status)}
                      styles={{control: (baseStyles, state) => (reactSelectControlStyles(baseStyles, state))}}
                      placeholder={t('All')}
                      onChange={e => onSelect(e, 'status')}
                      isClearable
              />
          </div>
          <div style={{width: '25%'}}>
              <CFormLabel>{t("emergency.reportStatus")}</CFormLabel>
              <Select options={reportStatusOptions}
                      value={reportStatusOptions?.find(el => el.value === state.reportStatus)}
                      styles={{control: (baseStyles, state) => (reactSelectControlStyles(baseStyles, state))}}
                      placeholder={t('All')}
                      onChange={e => onSelect(e, 'reportStatus')}
                      isClearable
              />
          </div>
      </div>
  );
};

export default FilterBlock;
